import React, { useState } from 'react';

function UrgentDocumentDelivery() {
  const [quote, setQuote] = useState('');


  const handleSubmitQuote = () => {
    alert(`Your free quote request has been submitted: ${quote}`);
  };

  return (
    <div>
      {/* Hero Section */}
      <div
        className="relative bg-cover bg-center h-[400px] md:h-[600px]"
        style={{ backgroundImage: "url('images/document.png')" }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative z-10 flex flex-col items-center justify-center text-center h-full text-white">
          <h1 className="text-4xl md:text-7xl font-semibold">Guaranteed Confidential Document Delivery</h1>
          <p className="text-lg md:text-xl mt-4 max-w-3xl mx-auto ">
            When you need a document delivered urgently and securely, rely on 1UKLogistics for guaranteed same-day delivery.
          </p>
        </div>
      </div>

      

      {/* Types of Documents We Deliver Section */}
      <section id="document-types" className="md:p-16 px-4 bg-gray-100 text-black">
        <div className="text-center">
          <h2 className="text-2xl md:text-4xl font-thin">Types of Documents We Deliver</h2>
          <p className="text-lg max-w-4xl mx-auto mt-4 font-thin">
          1UKLogistics specialises in delivering a wide range of important documents securely and swiftly. Whether you're handling architectural plans, legal documents, or sensitive medical files, our same-day service ensures that everything reaches its destination promptly and confidentially.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
          <div className="flex flex-col items-center bg-white shadow-lg p-6 rounded-lg">
            <h3 className="text-xl font-thin">Architectural & Engineering Drawings</h3>
            <p className="text-lg mt-4 font-thin">We ensure timely delivery of critical design files to support your projects.</p>
          </div>
          <div className="flex flex-col items-center bg-white shadow-lg p-6 rounded-lg">
            <h3 className="text-xl font-thin">Legal Documents</h3>
            <p className="text-lg mt-4 font-thin">We frequently work with the legal industry to deliver confidential documents securely.</p>
          </div>
          <div className="flex flex-col items-center bg-white shadow-lg p-6 rounded-lg">
            <h3 className="text-xl font-thin">Medical Documents</h3>
            <p className="text-lg mt-4 font-thin">We handle sensitive medical documents with the confidentiality and speed they require.</p>
          </div>
          <div className="flex flex-col items-center bg-white shadow-lg p-6 rounded-lg">
            <h3 className="text-xl font-thin">Passport Documents</h3>
            <p className="text-lg mt-4 font-thin">Urgent passport document delivery is managed efficiently for timely arrivals.</p>
          </div>
          <div className="flex flex-col items-center bg-white shadow-lg p-6 rounded-lg">
            <h3 className="text-xl font-thin">House Completion Documents</h3>
            <p className="text-lg mt-4 font-thin">We expedite the process by ensuring the timely delivery of house completion documents.</p>
          </div>
          <div className="flex flex-col items-center bg-white shadow-lg p-6 rounded-lg">
            <h3 className="text-xl font-thin">Tenders</h3>
            <p className="text-lg mt-4 font-thin">Prompt delivery of business tenders ensures your proposal reaches its destination quickly.</p>
          </div>
        </div>
      </section>

     

      {/* FAQ Section */}
      <section id="faq" className="py-16 bg-gray-100 text-black">
        <div className="text-center">
          <h2 className="text-2xl md:text-4xl font-thin">FAQ`s</h2>
          <div className="space-y-6 mt-8 max-w-4xl mx-auto">
            <div>
              <h3 className="text-xl font-thin">How does the same-day document delivery service work?</h3>
              <p className="text-lg mt-2 font-thin">
                Simply provide us with the details of the documents you need delivered, and we’ll ensure their prompt, secure transportation on the same day.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-thin">What types of documents can you deliver?</h3>
              <p className="text-lg mt-2 font-thin">
                We deliver a wide range of documents, including legal, medical, passport, architectural, and business-related documents.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-thin">Is the delivery service confidential?</h3>
              <p className="text-lg mt-2 font-thin">
                Yes, we guarantee the confidentiality and security of all documents in transit.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default UrgentDocumentDelivery;
